import { render, staticRenderFns } from "./healthManagement.vue?vue&type=template&id=9e74d50c&scoped=true"
import script from "./healthManagement.vue?vue&type=script&lang=js"
export * from "./healthManagement.vue?vue&type=script&lang=js"
import style0 from "./healthManagement.vue?vue&type=style&index=0&id=9e74d50c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e74d50c",
  null
  
)

export default component.exports